<template>
  <div class="container">
    <div class="days">
      <span
        class="day"
        v-for="(label, index) of visibleDays"
        @click="loadDay(index)"
        v-bind:class="{
          daySelected: daySelected === index,
          equalToSelected: isEqualToSelected(index),
        }"
      >
        {{ label.substr(0, 3) }}
      </span>
    </div>

    <table class="schedule">
      <tr v-for="row in hours">
        <td v-for="hour in row">
          <div
            @click="setHourMode(hour)"
            v-bind:class="getHourStyle(hour)"
            class="dayTable"
          >
            {{ getFormattedHour(hour) }}
          </div>
        </td>
      </tr>
    </table>

    <div class="columns is-centered is-variable is-5 icons">
      <div
        class="column is-1"
        @click="setMode('O')"
        v-bind:class="{ active: mode === 'O' }"
      >
        <img
          v-if="mode === 'O'"
          src="/home/images/program/btn_borrar_on_program.png"
          class="clickable optionTitle"
        />
        <img
          v-else
          src="/home/images/program/btn_borrar_off_program.png"
          class="clickable optionTitle"
        />
        <div class="optionText">{{ $t("thermostat.off") }}</div>
      </div>

      <div
        class="column is-1"
        @click="setMode('E')"
        v-bind:class="{ active: mode === 'E' }"
      >
        <img
          v-if="mode === 'E'"
          src="/home/images/program/btn_eco_on_program.png"
          class="clickable optionTitle"
        />
        <img
          v-else
          src="/home/images/program/btn_eco_off_program.png"
          class="clickable optionTitle"
        />
        <div class="optionText">{{ $t("thermostat.eco") }}</div>
      </div>
      <div
        class="column is-1"
        @click="setMode('C')"
        v-bind:class="{ active: mode === 'C' }"
      >
        <img
          v-if="mode === 'C'"
          src="/home/images/program/btn_confort_on_program.png"
          class="clickable optionTitle"
        />
        <img
          v-else
          src="/home/images/program/btn_confort_off_program.png"
          class="clickable optionTitle"
        />
        <div class="optionText">{{ $t("thermostat.comfort") }}</div>
      </div>
    </div>

    <br />

    <b-field :label="$t('program.duplicate')">
      <b-select v-model="copyDay" :placeholder="$t('form.select')" rounded>
        <option
          v-for="(label, index) in days"
          v-if="index !== daySelected"
          :value="index"
          :key="index"
        >
          {{ label }}
        </option>
      </b-select>
    </b-field>

    <br />

    <a class="button is-success" @click="copyProgram">
      {{ $t("program.copy") }}
    </a>
    <a class="button is-danger" @click="resetProgram">
      {{ $t("program.reset") }}
    </a>

    <br /><br />
  </div>
</template>

<script>
String.prototype.replaceAt = function (index, replacement) {
  return (
    this.substr(0, index) +
    replacement +
    this.substr(index + replacement.length)
  );
};

import constants from "@/config/constants";
import zapp from "@/util/zapp";
import i18n from "@/config/i18n";

export default {
  name: "program",
  props: {
    program: Array,
  },

  data() {
    return {
      daySelected: 0,
      days: i18n.t("days"),
      visibleDays: i18n.t("days").slice(0, -1),
      mode: "E",
      copyDay: 1,
    };
  },

  created() {},

  computed: {
    hours: function () {
      return zapp.range(1, 4).map((row) => {
        return zapp.range(6 * row - 5 - 1, 6 * row - 1);
      });
    },
  },

  methods: {
    resetProgram: function () {
      for (let $i = 0; $i <= 6; $i++) {
        this.program[$i] = constants.defaultProgram[0];
      }
      this.$forceUpdate();
    },

    copyProgram: function () {
      // last pos of days array
      const copyAllDays = this.days.length - 1;

      if (this.copyDay === this.daySelected) {
        return false;
      } else if (this.copyDay === copyAllDays) {
        for (let $i = 0; $i <= 6; $i++) {
          this.program[$i] = this.program[this.daySelected];
        }
      } else {
        this.program[this.copyDay] = this.program[this.daySelected];
      }

      this.$forceUpdate();
    },

    setHourMode: function (hour) {
      this.program[this.daySelected] = this.program[this.daySelected].replaceAt(
        hour,
        this.mode
      );
      this.$forceUpdate();
    },

    setMode: function (mode) {
      this.mode = mode;
    },

    getHourStyle: function (hour) {
      return {
        eco: this.program[this.daySelected][hour] === "E",
        sleep: this.program[this.daySelected][hour] === "O",
        comfort: this.program[this.daySelected][hour] === "C",
      };
    },

    loadDay: function (day) {
      this.daySelected = day;
      if (this.daySelected === this.copyDay) {
        this.copyDay = this.daySelected === 0 ? 1 : 0;
      }
    },

    isEqualToSelected: function (day) {
      return (
        day !== this.daySelected &&
        this.program[day] === this.program[this.daySelected] &&
        this.program.filter((value) => value !== "OOOOOOOOOOOOOOOOOOOOOOOO")
          .length > 0
      );
    },

    getFormattedHour(hours) {
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      return hours + ampm;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #efefef;
  border-radius: 15px;
}

.schedule {
  margin: 1.5rem auto;
}

.eco {
  background-color: green;
  color: white;
}

.comfort {
  background-color: orange;
  color: white;
}

.sleep {
  //background-color: white;
}

.control {
  text-align: center;
}

.button {
  margin: 0.5rem;
}

.days {
  padding: 2rem 0;
}

.day {
  margin: 0.5em;
  color: black;
  font-weight: bold;
  border: solid 1px green;
  border-radius: 10px;
  padding: 0.5% 0.5% 0.5% 0.7%;
  cursor: pointer;
}

.dayTable {
  font-weight: bold;
  padding: 2rem;
  cursor: pointer;
}

.daySelected {
  color: white;
  background-color: green;
}

.equalToSelected {
  color: green;
}

.modeSelected {
  color: green;
}

.optionText {
  display: none;
}

.active .optionTitle {
  padding-bottom: 0.5rem;
  border-bottom: solid 2px black;
}

.active .optionText {
  display: block;
}

.column img {
  height: 3rem;
}

@media screen and (max-width: 768px) {
  .dayTable {
    padding: 2rem 0.5rem;
  }
}
</style>
